import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '../../../components';

const propTypes = {
  edit: PropTypes.bool,
  type: PropTypes.string.isRequired,
};
const defaultProps = {
  edit: false,
};

function UnknownField({ edit, type }) {
  if (edit) {
    return (
      <Card>
        <Card.Title>
          {`Unknown field of type ${type}. Please delete this field.`}
        </Card.Title>
      </Card>
    );
  }

  console.log('Unknown field type. Nothing will be displayed for this field.');
  return null;
}

UnknownField.propTypes = propTypes;
UnknownField.defaultProps = defaultProps;
export default UnknownField;
